import React from 'react';
import Div from '../Element/Div/Div';
import Span from '../Element/Span/Span';
import TagText from '../Typography/TagText/TagText';
import styles from './Tag.module.scss';
import { ArrayElementType } from '../../types/utils/ArrayElementType';
import { CreateProps } from '../../types/utils/CreateProps';

type TagProps = CreateProps<
  {
    /** Custom background color for the tag */
    backgroundColor?: SupportedTagColor;
  },
  typeof Span,
  'backgroundColor' | 'inlineBlock' | 'borderRadius'
>;
// Alias for backwards compatibility
export type TagAttributes = TagProps;

const Tag: React.FunctionComponent<TagProps> = ({
  backgroundColor = 'red600',
  children,
  ...props
}) => {
  const tagText = children || <>&nbsp;</>;

  return (
    <Span
      {...props}
      backgroundColor={backgroundColor}
      inlineBlock
      borderRadius={{ size: 'sm' }}
    >
      <Div
        className={styles.tag__text}
        padding={{ vertical: 'xxs', horizontal: 'xs' }}
        responsiveHidden={{ thinnerThan: 'sm' }}
      >
        <TagText
          size="md"
          color={backgroundColor === 'orange400' ? 'orange800' : 'white'}
          block
        >
          {tagText}
        </TagText>
      </Div>

      <Div
        className={styles.tag__text}
        padding={{ vertical: 'xxxs', horizontal: 'xxs' }}
        responsiveHidden={{ widerThan: 'xs' }}
      >
        <TagText
          color={backgroundColor === 'orange400' ? 'orange800' : 'white'}
          size="sm"
          block
        >
          {tagText}
        </TagText>
      </Div>
    </Span>
  );
};

export const supportedTagColors = [
  'gray400',
  'black',
  'red600',
  'purple500',
  'blue600',
  'orange400',
] as const;

export type SupportedTagColor = ArrayElementType<typeof supportedTagColors>;

export default Tag;
